// extracted by mini-css-extract-plugin
export default {"event-title":"eO8NpfGu0KQ7FW0JARK6"};